import { axiosInstanceWebsite } from "../instance";

export interface DropiIntegrationInterface {
    integration_token: string;
    is_active: boolean;
}

export interface MastershopIntegrationInterface {
    api_key: string;
    is_active: boolean;
    connected?: boolean;
}

export const getDropiIntegrations = async () => {
    const response = await axiosInstanceWebsite.get(`/order/dropi/integration`);
    return response.data;
};

export const postDropiIntegration = async (data: DropiIntegrationInterface) => {
    const response = await axiosInstanceWebsite.post(`/order/dropi/integration`, data);
    return response.data;
};

export const getMastershopIntegrations = async () => {
    const response = await axiosInstanceWebsite.get(`/order/mastershop/integration`);
    return response.data;
};

export const postMastershopIntegration = async (data: MastershopIntegrationInterface) => {
    const response = await axiosInstanceWebsite.post(`/order/mastershop/integration`, data);
    return response.data;
};

export const getIntegrationsAvailability = async () => {
    const response = await axiosInstanceWebsite.get(`/integrations/availability`);
    return response.data;
};
